<template>
  <div>
    <CommonDialog
      :dialog="dialogSuccessors"
      :head-text="$t('buttons.update')"
      :confirm-button="{
        text: $t('buttons.update'),
        icon: 'mdi-plus'
      }"
      :on-confirm="
        () => {
          $refs['form-meter'].save(callback);
        }
      "
      :on-cancel="() => (dialogSuccessors = false)"
    >
      <FormMeter
        ref="form-meter"
        dispatch="projectMeteringStore/meterStore/create"
        :meter="{ ...meterClone, id: undefined }"
        hideButtons
      ></FormMeter>
    </CommonDialog>
    <h2 class="mt-3">{{ $t(`life-cycle.set-predecessors`) }}</h2>
    <v-form ref="predecessor">
      <TreeSelector
        v-model="meterId"
        :rules="[rules.required]"
        :label="$t('meters.meters')"
        :items="meters"
        :options-for-tree-items="{
          groupKey: '_groups',
          canChooseGroup: false
        }"
      ></TreeSelector>
      <DateTimeInput
        :date="date"
        @update="
          val => {
            date = val;
          }
        "
        :label="$t('life-cycle.effective-at')"
        :rules="[rules.required]"
        clearable
      ></DateTimeInput>
      <v-btn color="primary" :loading="loading" v-on:click="createPredecessor">
        <v-icon left>mdi-plus</v-icon>
        {{ $t(`buttons.update`) }}
      </v-btn>
    </v-form>
    <h2 class="mt-3">{{ $t(`life-cycle.predecessors`) }}</h2>
    <CommonTable
      class="table"
      list-getter="projectMeteringStore/meterStore/getListPredecessors"
      delete-item-dispatch="projectMeteringStore/meterStore/deletePredecessor"
      @updated="updatePredecessors"
      :headers="headers"
      :slots="slots"
      :actions="actions"
      :static-dispatch-params="{ id: id }"
      resource="life-cycle"
      :loading="loadingPredecessors"
      :defaultEmptyFooter="false"
    ></CommonTable>
    <template v-if="this.loadingSuccessors || successors.length">
      <h2>{{ $t(`life-cycle.successors`) }}</h2>
      <CommonTable
        class="table"
        list-getter="projectMeteringStore/meterStore/getListSuccessors"
        :headers="headers"
        :slots="slots"
        :actions="[]"
        :static-dispatch-params="{ id: id }"
        resource="life-cycle"
        :loading="loadingSuccessors"
      ></CommonTable>
    </template>
    <template v-else>
      <v-divider class="my-5" />
      <h2 class="mt-3">{{ $t(`life-cycle.set-successor`) }}</h2>
      <v-form ref="successor">
        <DateTimeInput
          :date="dateSuccessors"
          @update="
            val => {
              dateSuccessors = val;
            }
          "
          :label="$t('life-cycle.effective-at')"
          :rules="[rules.required]"
          clearable
        ></DateTimeInput>
        <v-row>
          <v-col cols="6">
            <v-checkbox
              v-for="item in meter['_meter_units']"
              v-model="meterUnits[item.id]"
              :label="$t('life-cycle.recreate') + item.name"
              color="primary"
              class="ma-0"
              v-bind:key="item.id"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-btn color="primary" :loading="loading" v-on:click="createSuccessor">
          <v-icon left>mdi-plus</v-icon>
          {{ $t(`buttons.update`) }}
        </v-btn>
      </v-form>
    </template>
  </div>
</template>

<script>
import CommonTable from "../../../common/tables/CommonTable";
import DateTimeInput from "../../../common/inputs/DateTimeInput";
import CommonDialog from "../../../common/dialogs/CommonDialog";
import TreeSelector from "../../../common/inputs/TreeSelector";
import FormMeter from "./FormMeter";

import moment from "moment";
import { rules } from "../../../mixins/rules";

export default {
  name: "LifeCycleMeter",
  components: {
    CommonTable,
    DateTimeInput,
    CommonDialog,
    TreeSelector,
    FormMeter
  },
  props: ["id"],
  mixins: [rules],
  data: function() {
    return {
      loading: true,
      loadingPredecessors: true,
      loadingSuccessors: true,
      dialogSuccessors: false,
      headers: [
        {
          text: this.$t("meters.name"),
          align: "left",
          value: "name"
        },
        {
          text: this.$t("meters.groups"),
          value: "_groups",
          sortable: false
        },
        {
          text: this.$t("life-cycle.effective-at"),
          value: "effective_at",
          sortable: false
        },
        {
          text: this.$t("life-cycle.action"),
          value: "action",
          align: "right",
          sortable: false
        }
      ],
      actions: [
        {
          type: "delete",
          showFunction: item =>
            this.predecessors.findIndex(i => i._meter.id === item.id) === 0
        }
      ],

      meterId: "",
      date: "",
      dateSuccessors: "",
      meterUnits: {}
    };
  },
  computed: {
    successors() {
      return this.$store.getters[
        "projectMeteringStore/meterStore/getListSuccessors"
      ];
    },
    predecessors() {
      return (
        this.$store.getters[
          "projectMeteringStore/meterStore/getListPredecessors"
        ] || []
      );
    },
    meter() {
      return this.$store.getters["projectMeteringStore/meterStore/getItem"];
    },
    meterClone() {
      return JSON.parse(JSON.stringify(this.meter));
    },
    meters() {
      return this.$store.getters[
        "projectMeteringStore/meterStore/getList"
      ].filter(i => i.id !== this.meter.id);
    },
    project() {
      return this.$store.getters["projectStore/getItem"];
    },
    slots() {
      return [
        {
          name: "name",
          type: "link",
          to: "meter",
          linkParams: {
            id: "id"
          }
        },
        {
          name: "_groups",
          type: "groups",
          to: "group",
          divider: " > "
        },
        {
          name: "effective_at",
          type: "date",
          dateFormat: "long",
          dateTimeZone: this.project.timezone
        }
      ];
    }
  },
  methods: {
    createPredecessor() {
      this.clearBackEndErrors();
      if (this.$refs.predecessor.validate()) {
        this.loading = true;
        let item = {
          id: this.id,
          project_id: this.$route.params.project_id,
          _meter: {
            id: this.meterId
          },
          effective_at: moment.utc(this.date).format("YYYY-MM-DDTHH:mm:ss[Z]")
        };
        this.$store
          .dispatch("projectMeteringStore/meterStore/createPredecessor", {
            item,
            errorHandler: this.errorHandler.bind(this, () => {
              this.$refs.predecessor.validate();
            })
          })
          .finally(() => {
            this.updatePredecessors();
            this.updateSuccessors();
            this.loading = false;
          });
      }
    },
    createSuccessor() {
      this.clearBackEndErrors();
      if (this.$refs.successor.validate()) {
        this.dialogSuccessors = true;
      }
    },
    updatePredecessors() {
      this.loadingPredecessors = true;
      this.$store.dispatch(
        "projectMeteringStore/meterStore/getListPredecessors",
        {
          params: {
            limit: -1,
            project_id: this.$route.params.project_id,
            id: this.id
          },
          onSuccess: () => {
            this.loadingPredecessors = false;
          }
        }
      );
    },
    updateSuccessors() {
      this.loadingSuccessors = true;
      this.$store
        .dispatch("projectMeteringStore/meterStore/getListSuccessors", {
          params: {
            limit: -1,
            project_id: this.$route.params.project_id,
            id: this.id
          },
          onSuccess: () => {}
        })
        .finally(() => (this.loadingSuccessors = false));
    },
    callback(newMeter) {
      let item = {
        id: newMeter.id,
        project_id: this.$route.params.project_id,
        _meter: {
          id: this.id
        },
        _meter_units: Object.entries(this.meterUnits)
          .map(i => {
            if (i[1]) {
              return { id: i[0] };
            }
          })
          .filter(i => i),
        effective_at: moment
          .utc(this.dateSuccessors)
          .format("YYYY-MM-DDTHH:mm:ss[Z]")
      };
      this.$store
        .dispatch("projectMeteringStore/meterStore/createPredecessor", {
          item,
          errorHandler: this.errorHandler.bind(this, () => {
            this.$refs.predecessor.validate();
          })
        })
        .finally(() => {
          this.updatePredecessors();
          this.updateSuccessors();
          this.loading = false;
          this.dialogSuccessors = false;
        });
    }
  },
  mounted() {
    this.updatePredecessors();
    this.updateSuccessors();
    this.$store.dispatch("projectMeteringStore/meterStore/getList", {
      params: {
        limit: -1,
        project_id: this.$route.params.project_id
      },
      onSuccess: () => {
        this.loading = false;
      }
    });
  }
};
</script>

<style scoped>
.table {
  height: auto;
}
</style>
